module.exports = __webpack_public_path__ + "static/media/betakit-logo.eb73460f.png";